<template>
	<div id="app">
		<router-view
				v-wechat-title="title"
				@updateUserInfo="getUserInfoToServer"
				@loginOut="loginOut"
				@share="setShareData"
				@setSiteTitle="setSiteTitle"
				@isLogin="isLogin"
				v-bind:userInfo="userInfo"
				v-bind:base="base"
				v-bind:config="config"
		/>
		<Loading id="loading" class="layui-anim"/>
	</div>
</template>

<script>
import Public from './assets/api/Public'
import Local from "./controller/continue/local";
import CPs from './controller/public/index'
import CRs from './controller/route/index'
import RouteMultiple from "./controller/route/multiple";
import Login from "./assets/api/Login";

export default {
	name: 'App',
	data() {
		return {
			loadIs:true,
			Api: {},
			Public: {},
			Locals: {},
			Local: {},
			userInfo: {
				"id": 0,
				"nickname": "",
				"sex": 1,
				"realname": "",
				"tel": "",
                "sn": "",
				"headimgurl": "",
				"score2": 0,
				"money2": 0,
				"wx_bd": 0,
				"wx_pay_id": '',
				"wxid": '',
                "auth": '',
				"islock": 0,
				"ewm": "",
				"team_count": 0,
				"addr_count": 0,
				"wxAvatar": {
					"id": 0,
					"uid": 0,
					"subscribe": 0,
					"wxid": "",
					"nickname": "",
					"sex": 0,
					"city": "",
					"country": "",
					"province": "",
					"language": "",
					"headimgurl": "",
					"subscribe_time": 0,
					"localimgurl": "",
					"setp": 0,
					"uname": "",
					"affiliate": 0,
					"dateline": 0
				}
			},
			JsSdkConfig: {},
			base: $___WEBSITE__$,
			config: {},
			CP: {},
			title: '',
			shareParams: {
				title: '',  // 分享标题
				desc: '',   // 分享描述
				link: '',   // 分享链接
				imgUrl: '', // 分享图片
			},
			...RouteMultiple.data,
			CR: {},
			shareid: '0',
		}
	},
	created() {
		let That = this;
		That.Public = new Public(That);
		That.Locals = new Local(That);
		That.CP = new CPs();
		That.config = $CONFIG$;
		That.Api = new Login(That);
		That.Local = new Local();
		That.CR = new CRs();
		That.CP = new CPs();
		if (!this.query('code')) {
			That.getUserInfoToServer();
		}
		if (this.query('shareid')) {
			That.shareid = this.query('shareid');
		}

	},
	mounted(){
		this.initCNZZ();
	},
	methods: {
		initCNZZ() {
			var srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i;
			let scriptString = this.base.webSite.site_tj;
			if(scriptString !== ''){
				let src = scriptString.match(srcReg)[1];
				const script = document.createElement('script');
				script.src = src;
				script.language = 'JavaScript';
				script.id='cnzz';
				document.body.appendChild(script);
			}
		},
		setSiteTitle: function (e) {
			let That = this;
			That.title = That.setTitle(e);
		},
		setShareData: function (e) {
			let That = this;
			That.title = That.setTitle(e.title);
			e.title = That.setTitle(e.title);
			e.link = That.shareParams.link;
			That.shareParams = e;
		},
		createShareUrlParams: function () {
			return this.rebuildParams(window.location.href, {shareid: this.userInfo.id}, ['code','shareid','classify_id']);
		},
		getUserInfoToServer: function (force = false) {
			let That = this;
			if(this.$route.meta.loginIn !== undefined && this.$route.meta.loginIn === true || this.isWeChat() || force){
				if(this.loadIs){
					this.loadIs = false;
					That.Public.getUserInfo({}).then(res => {
						That.loadIs = true;
						if (res.code === 200) {
							That.Locals.set('userInfo', JSON.stringify(res.data));
							That.loadUserInfo(res.data);
						}
					});
				}
			}
		},
		loadUserInfo: async function (userInfo) {
			let That = await this;
			That.userInfo = userInfo;
			if (That.base.webSite.must_phone === 1) {
				if (userInfo.tel === '') {
					That.$router.push({
						path: '/my/setting/binding'
					})
				}
			}
			That.$forceUpdate();
		},
		loadUserJsSdkConfig: function ($url = window.location.href) {
			let That = this;
			That.Public.getUserJsSdkConfig({url: $url}).then(res => {
				if (res.code === 200) {
					That.JsSdkConfig = res.data;
				}
			});
		},
		setTitle: function (title) {
			let That = this;
			let SiteTitle = '';
			if (That.$route.path === '/') {
				SiteTitle = That.base.webSite.site_title;
			} else {
				SiteTitle = That.base.webSite.site_name;
			}
			let Titles = title;
			if (title !== undefined && title !== '') {
				if (title.indexOf(SiteTitle) === -1) {
					Titles += '-' + SiteTitle;
				}
			} else {
				Titles += SiteTitle;
			}
			return Titles;
		},
		isLogin: function (manual = false, die = false) {
			let That = this;
			if ((this.$route.meta.loginIn !== undefined && !this.query('code')) || manual) {
				let Token = That.CP.token();
				if (Token === '' || Token === 'null' || Token === 'undefined' || Token === null || Token === undefined || die) {
					let path = window.location.href;
					// START------防止路由打滑
					for (let i = 0; i++; i < 6) {
						if (window.location.pathname !== '/') break;
						path = window.location.href;
					}
					// END------防止路由打滑
					path = this.rebuildParams(path, {}, ['code']);
					if (this.isWeChat()) {
						this.wechatSign(path);
					} else {
						this.$router.push({
							path: '/sign/sign?redirect_uri=' + path
						})
					}
				}
			}else{
				this.wechatSignIn()
			}
		},
		wechatSignIn:async function(){
			let That = this;
			if (this.query('code') && this.query('state') && this.query('state') === 'STATE') {
				$.ajax({
					url:That.ApiUrl('getUserAccessToken'),
					type:'post',
					data:{
						code: That.query('code'),
						shareid: That.shareid
					},
					async:false,
					success:function (res) {
						if (res.code === 200) {
							That.Local.set('userInfo', JSON.stringify(res.data));
							That.loadUserInfo(res.data);
							if (res.data.token.token) {
								That.Local.set('token', res.data.token.token);
							}
							if (res.data.token.time) {
								That.Local.set('time', res.data.token.time);
							}
						} else {
							That.getUserInfoToServer();
						}
					}
				})
			}
		},
		loginOut: function () {
			this.Locals.clearAll();
			this.$router.push({
				path: '/'
			})
		},
		setWeChartShareParams: function () {
			let That = this;
			wx.ready(function () {
				wx.onMenuShareAppMessage({
					...That.shareParams,
					success: function () {
					}
				});
				wx.updateTimelineShareData({
					title: That.shareParams.title,
					link: That.shareParams.link,
					imgUrl: That.shareParams.imgUrl,
					success: function () {
					}
				})
			})
		},
		...RouteMultiple.methods
	},
	watch: {
		shareParams: function (e) {
			let That = this;
			That.title = this.setTitle(e.title)
			if (this.isWeChat()) {
				if (e.title === '') {
					this.shareParams.title = this.base.webSite.site_title;
				}
				if (e.desc === '') {
					this.shareParams.desc = this.base.webSite.site_desc;
				}
				if (e.imgUrl === '') {
					this.shareParams.imgUrl = this.base.webSite.site_logo;
				}
				this.setWeChartShareParams();
			}
		},
		JsSdkConfig: function (e) {
			wx.config({
				debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
				appId: e.appid, // 必填，公众号的唯一标识
				timestamp: e.timestamp, // 必填，生成签名的时间戳
				nonceStr: e.nonceStr, // 必填，生成签名的随机串
				signature: e.signature,// 必填，签名
				jsApiList: [
					'onMenuShareAppMessage',
					'updateTimelineShareData'
				] // 必填，需要使用的JS接口列表
			});
		},
		userInfo: function (e) {
			if (this.isWeChat()) {
				this.shareParams.link = this.createShareUrlParams();
			}
		},
		$route: function (to, from) {
			let That = this;

			if (That.isWeChat()) {
				if (That.$route.name !== 'weChartSign' && That.$route.name !== 'webSign') {
					if(That.query('code')){
						That.wechatSignIn();
					}else{
						That.isLogin(true)
					}
				}
			} else {
				if (That.$route.name !== 'weChartSign' && That.$route.name !== 'webSign') {
					That.isLogin(false);
				}
			}
			this.loadUserJsSdkConfig(window.location.href);

			That.title = That.setTitle(That.$route.meta.title || '');
			if (That.isWeChat()) {
				That.shareParams = {
					imgUrl: That.getImgSrc(That.base.webSite.site_logo),
					link: That.createShareUrlParams(),
					title: That.title,
					desc: That.base.webSite.site_desc,
				}
			}

			That.routeHistory.push(to.path);

			if (window._czc) {
				//监听路由变化
				let location = window.location;
				let contentUrl = location.pathname + location.hash;
				let refererUrl = '/';
				window._czc.push(['_trackPageview', contentUrl, refererUrl])
			}

		},
		...RouteMultiple.watch
	},
}
</script>

<style>
@import "./assets/css/public/style.css";
</style>



// WEBPACK FOOTER //
// src/App.vue